// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stellenausschreibungen-container {
  margin-bottom: 4rem;
}

.bottom-spacer {
  height: 0.5rem;
}

.job-category {
  margin-bottom: 20px;
}

.job-title {
  background-color: #ed5622;
  color: var(--blassgruen);
  font-family: 'Staatliches', sans-serif;
  font-weight: normal;
  text-align: left;
  padding: 10px 15px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: -12px;
  transition: 0.2s ease;
  margin-bottom: 0; /* Remove margin-bottom to avoid spacing issues */
  font-size: 25px;
}

.job-title.expanded {
  background-color: var(--primary-light); /* Use light background color when expanded */
  color: var(--blutorange); /* Adjust text color for better contrast */
  font-family: 'Staatliches', sans-serif;
  border-top: 2px solid var(--blutorange);
  border-left: 2px solid var(--blutorange);
  border-right: 2px solid var(--blutorange);
  border-radius: 10px 10px 0px 0px;
}

.job-arrow {
  transition: transform 0.3s ease;
  color: var(--blassgruen);
  font-family: 'Material Symbols Outlined';
  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 40;
  font-size: 40px;
}

.job-title.expanded .job-arrow {
  color: var(--blutorange);
}

.job-details {
  /* border: 2px solid #ed5622; */
  /* padding: 10px; */
  margin-top: 0; /* Ensure no gap between title and details */
  background-color: var(--primary-light); /* Use light background color */
  color: #ed5622; /* Adjust text color for better contrast */
  line-height: 1.5;
  max-height: 0;
  overflow: hidden;
  transition: 0.3s ease;
}

.job-details.expanded {
  border-bottom: 2px solid #ed5622;
  border-left: 2px solid #ed5622;
  border-right: 2px solid #ed5622;
  border-radius: 0px 0px 10px 10px;
  padding: 0.5rem 1rem 1rem;
  max-height: 500px; /* Adjust this value based on the content height */
  background-color: var(--primary-light); /* Use light background color */
}

.job-description {
  margin: 0.5rem 0;
  font-family: 'Circular', sans-serif;
  color: var(--blutorange);
  font-weight: normal;
  text-align: left;
}

.job-detail-item {
  margin: 0.7rem 0;
  font-family: 'Circular', sans-serif;
  font-weight: normal;
  color: var(--blutorange);
  display: flex;
  align-items: center;
  gap: 5px;
}

.job-detail-item .material-symbols-outlined {
  color: var(--blutorange);
  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 40;
}

.stellenausschreibungen-container .location-link {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-top: 0.3rem;
}

.stellenausschreibungen-container .location-label {
  color: var(--blutorange);
  text-decoration: underline;
  text-underline-offset: 4px;
  font-family: 'Staatliches', sans-serif;
  font-weight: normal;
  font-size: 1.3rem;
}

.stellenausschreibungen-container .location-icon {
  color: var(--blutorange);
  stroke: var(--blutorange);
  stroke-width: 1.2;
  font-size: 1.3rem;
}

.job-details strong {
  font-family: 'Circular', sans-serif;
}


.stellenausschreibungen-container button {
  display: inline-block;
  background-color: #ed5622;
  color: var(--primary-light);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1em;
  font-family: 'Staatliches', sans-serif;
  font-weight: normal;
  transition: background-color 0.3s ease;
}

.stellenausschreibungen-container button:hover {
  background-color: var(--primary-dark);
}


.job-calendar {
  width: 100%;
  border-collapse: collapse;
  margin: 1rem 0;
  background-color: var(--hellgruen);
  border-radius: 12px;
  overflow: hidden;
  border: none;
}

.job-calendar th,
.job-calendar td {
  padding: 0.6rem;
  text-align: center;
  width: 20%;
  background-color: var(--hellgruen);
  color: var(--dunkelgruen);
  border: none;
  font-weight: normal;
  font-family: 'Circular', sans-serif;
  line-height: 0.8;
}

.job-calendar thead th {
  background-color: var(--dunkelgruen);
  color: var(--blassgruen);
  font-size: calc(1rem + 8px);
  border-bottom: none;
  border-top: none;
}

.job-calendar th {
  font-family: 'Staatliches', sans-serif;
}

.job-calendar td {
  font-size: calc(1rem + 6px);
  font-weight: normal;
}

.job-calendar tbody tr:first-child {
  border-bottom: 2px solid var(--dunkelgruen);
}

.job-calendar tbody tr:last-child td {
  border-bottom: none;
}

.job-calendar .green,
.job-calendar .red {
  background-color: var(--hellgruen);
  color: var(--dunkelgruen);
}


.filters {
  display: flex; /* Display filters in a row */
  justify-content: flex-start; /* Align filters to the left */
  gap: 15px; /* Add spacing between filter items */
  margin-top: 0;
  margin-bottom: 20px;
}

.filters label {
  display: flex;
  align-items: center;
  font-size: 1em;
  color: var(--dunkelgruen);
}

.filter-head {
  display: flex;
  gap: 10px; /* Abstand zwischen den Elementen */
  margin-bottom: 10px;
  background-color: var(--blassgruen);
  padding: 5px 10px;
}



.search-wrapper {
  position: relative;
  flex-grow: 1;
  display: flex;
  align-items: center;
}

.search-wrapper::after {
  content: "";
  position: absolute;
  left: 40px;
  right: 10px;
  bottom: 23px;
  height: 2px;
  background-color: var(--dunkelgruen);
}

.search-wrapper input[type="text"] {
  width: 100%;
  padding: 5px 0 5px 40px;
  border: none;
  border-radius: 0;
  outline: none;
  background-color: transparent;
  box-shadow: none;
  color: var(--dunkelgruen);
}

.search-wrapper input[type="text"]::placeholder {
  color: var(--hellgruen);
  font-size: 1.2em;
}

.search-icon {
  position: absolute;
  left: 0;
  top: calc(50% - 8px);
  transform: translateY(-50%);
  pointer-events: none;
  color: var(--dunkelgruen);
  font-family: 'Material Symbols Outlined';
  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 40;
  font-size: 30px;
}

.filter-head button {
  flex-shrink: 0; /* Prevent the button from growing */
  width: auto; /* Set a smaller width for the button */
  padding: 5px 15px; /* Adjust padding for a smaller button */
  font-family: 'Staatliches', sans-serif;
  font-weight: normal;
  background-color: var(--primary-dark); /* Distinct background color */
  color: var(--primary-light); /* Text color */
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
  margin-top: 0px;
}

.filter-head button:hover {
  background-color: #ed5622; /* Hover effect */
  color: var(--primary-dark); /* Invert text color on hover */
}

.filter-head .filter-text {
  display: inline-block;
  padding: 5px 15px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1em;
  color: var(--dunkelgruen);
  transition: background-color 0.3s ease, color 0.3s ease;
  height: 10%;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.filter-text {
  display: inline-block;
  padding: 5px 15px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1em;
  color: var(--dunkelgruen);
  transition: background-color 0.3s ease, color 0.3s ease;
  height: 10%;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.filter-head .filter-text.selected {
  background-color: #ed5622; /* Highlight background when selected */
  color: var(--primary-light); /* Invert text color when selected */
}

.filter-text.selected svg path{
  color: var(--primary-light)
}

.filters .filter-text.selected {
  background-color: #ed5622; /* Highlight background when selected */
  color: var(--primary-light); /* Invert text color when selected */
}`, "",{"version":3,"sources":["webpack://./src/components/jobs/stellenausschreibungen/Stellenausschreibungen.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB,EAAE,iDAAiD;EACnE,eAAe;AACjB;;AAEA;EACE,sCAAsC,EAAE,6CAA6C;EACrF,wBAAwB,EAAE,0CAA0C;EACpE,sCAAsC;EACtC,uCAAuC;EACvC,wCAAwC;EACxC,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,wCAAwC;EACxC,kEAAkE;EAClE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa,EAAE,4CAA4C;EAC3D,sCAAsC,EAAE,+BAA+B;EACvE,cAAc,EAAE,0CAA0C;EAC1D,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,yBAAyB;EACzB,iBAAiB,EAAE,kDAAkD;EACrE,sCAAsC,EAAE,+BAA+B;AACzE;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,kEAAkE;AACpE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,sCAAsC;EACtC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;;AAGA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sCAAsC;EACtC,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;;AAGA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kCAAkC;EAClC,yBAAyB;AAC3B;;;AAGA;EACE,aAAa,EAAE,6BAA6B;EAC5C,2BAA2B,EAAE,8BAA8B;EAC3D,SAAS,EAAE,qCAAqC;EAChD,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS,EAAE,mCAAmC;EAC9C,mBAAmB;EACnB,mCAAmC;EACnC,iBAAiB;AACnB;;;;AAIA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,oBAAoB;EACpB,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;EACzB,wCAAwC;EACxC,kEAAkE;EAClE,eAAe;AACjB;;AAEA;EACE,cAAc,EAAE,oCAAoC;EACpD,WAAW,EAAE,uCAAuC;EACpD,iBAAiB,EAAE,wCAAwC;EAC3D,sCAAsC;EACtC,mBAAmB;EACnB,qCAAqC,EAAE,8BAA8B;EACrE,2BAA2B,EAAE,eAAe;EAC5C,eAAe;EACf,uDAAuD;EACvD,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,0BAA0B,EAAE,+BAA+B;AAC7D;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,uDAAuD;EACvD,WAAW;EACX,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,uDAAuD;EACvD,WAAW;EACX,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB,EAAE,uCAAuC;EAClE,2BAA2B,EAAE,oCAAoC;AACnE;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB,EAAE,uCAAuC;EAClE,2BAA2B,EAAE,oCAAoC;AACnE","sourcesContent":[".stellenausschreibungen-container {\n  margin-bottom: 4rem;\n}\n\n.bottom-spacer {\n  height: 0.5rem;\n}\n\n.job-category {\n  margin-bottom: 20px;\n}\n\n.job-title {\n  background-color: #ed5622;\n  color: var(--blassgruen);\n  font-family: 'Staatliches', sans-serif;\n  font-weight: normal;\n  text-align: left;\n  padding: 10px 15px;\n  border-radius: 10px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: -12px;\n  transition: 0.2s ease;\n  margin-bottom: 0; /* Remove margin-bottom to avoid spacing issues */\n  font-size: 25px;\n}\n\n.job-title.expanded {\n  background-color: var(--primary-light); /* Use light background color when expanded */\n  color: var(--blutorange); /* Adjust text color for better contrast */\n  font-family: 'Staatliches', sans-serif;\n  border-top: 2px solid var(--blutorange);\n  border-left: 2px solid var(--blutorange);\n  border-right: 2px solid var(--blutorange);\n  border-radius: 10px 10px 0px 0px;\n}\n\n.job-arrow {\n  transition: transform 0.3s ease;\n  color: var(--blassgruen);\n  font-family: 'Material Symbols Outlined';\n  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 40;\n  font-size: 40px;\n}\n\n.job-title.expanded .job-arrow {\n  color: var(--blutorange);\n}\n\n.job-details {\n  /* border: 2px solid #ed5622; */\n  /* padding: 10px; */\n  margin-top: 0; /* Ensure no gap between title and details */\n  background-color: var(--primary-light); /* Use light background color */\n  color: #ed5622; /* Adjust text color for better contrast */\n  line-height: 1.5;\n  max-height: 0;\n  overflow: hidden;\n  transition: 0.3s ease;\n}\n\n.job-details.expanded {\n  border-bottom: 2px solid #ed5622;\n  border-left: 2px solid #ed5622;\n  border-right: 2px solid #ed5622;\n  border-radius: 0px 0px 10px 10px;\n  padding: 0.5rem 1rem 1rem;\n  max-height: 500px; /* Adjust this value based on the content height */\n  background-color: var(--primary-light); /* Use light background color */\n}\n\n.job-description {\n  margin: 0.5rem 0;\n  font-family: 'Circular', sans-serif;\n  color: var(--blutorange);\n  font-weight: normal;\n  text-align: left;\n}\n\n.job-detail-item {\n  margin: 0.7rem 0;\n  font-family: 'Circular', sans-serif;\n  font-weight: normal;\n  color: var(--blutorange);\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.job-detail-item .material-symbols-outlined {\n  color: var(--blutorange);\n  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 40;\n}\n\n.stellenausschreibungen-container .location-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  margin-top: 0.3rem;\n}\n\n.stellenausschreibungen-container .location-label {\n  color: var(--blutorange);\n  text-decoration: underline;\n  text-underline-offset: 4px;\n  font-family: 'Staatliches', sans-serif;\n  font-weight: normal;\n  font-size: 1.3rem;\n}\n\n.stellenausschreibungen-container .location-icon {\n  color: var(--blutorange);\n  stroke: var(--blutorange);\n  stroke-width: 1.2;\n  font-size: 1.3rem;\n}\n\n.job-details strong {\n  font-family: 'Circular', sans-serif;\n}\n\n\n.stellenausschreibungen-container button {\n  display: inline-block;\n  background-color: #ed5622;\n  color: var(--primary-light);\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1em;\n  font-family: 'Staatliches', sans-serif;\n  font-weight: normal;\n  transition: background-color 0.3s ease;\n}\n\n.stellenausschreibungen-container button:hover {\n  background-color: var(--primary-dark);\n}\n\n\n.job-calendar {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 1rem 0;\n  background-color: var(--hellgruen);\n  border-radius: 12px;\n  overflow: hidden;\n  border: none;\n}\n\n.job-calendar th,\n.job-calendar td {\n  padding: 0.6rem;\n  text-align: center;\n  width: 20%;\n  background-color: var(--hellgruen);\n  color: var(--dunkelgruen);\n  border: none;\n  font-weight: normal;\n  font-family: 'Circular', sans-serif;\n  line-height: 0.8;\n}\n\n.job-calendar thead th {\n  background-color: var(--dunkelgruen);\n  color: var(--blassgruen);\n  font-size: calc(1rem + 8px);\n  border-bottom: none;\n  border-top: none;\n}\n\n.job-calendar th {\n  font-family: 'Staatliches', sans-serif;\n}\n\n.job-calendar td {\n  font-size: calc(1rem + 6px);\n  font-weight: normal;\n}\n\n.job-calendar tbody tr:first-child {\n  border-bottom: 2px solid var(--dunkelgruen);\n}\n\n.job-calendar tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.job-calendar .green,\n.job-calendar .red {\n  background-color: var(--hellgruen);\n  color: var(--dunkelgruen);\n}\n\n\n.filters {\n  display: flex; /* Display filters in a row */\n  justify-content: flex-start; /* Align filters to the left */\n  gap: 15px; /* Add spacing between filter items */\n  margin-top: 0;\n  margin-bottom: 20px;\n}\n\n.filters label {\n  display: flex;\n  align-items: center;\n  font-size: 1em;\n  color: var(--dunkelgruen);\n}\n\n.filter-head {\n  display: flex;\n  gap: 10px; /* Abstand zwischen den Elementen */\n  margin-bottom: 10px;\n  background-color: var(--blassgruen);\n  padding: 5px 10px;\n}\n\n\n\n.search-wrapper {\n  position: relative;\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n}\n\n.search-wrapper::after {\n  content: \"\";\n  position: absolute;\n  left: 40px;\n  right: 10px;\n  bottom: 23px;\n  height: 2px;\n  background-color: var(--dunkelgruen);\n}\n\n.search-wrapper input[type=\"text\"] {\n  width: 100%;\n  padding: 5px 0 5px 40px;\n  border: none;\n  border-radius: 0;\n  outline: none;\n  background-color: transparent;\n  box-shadow: none;\n  color: var(--dunkelgruen);\n}\n\n.search-wrapper input[type=\"text\"]::placeholder {\n  color: var(--hellgruen);\n  font-size: 1.2em;\n}\n\n.search-icon {\n  position: absolute;\n  left: 0;\n  top: calc(50% - 8px);\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: var(--dunkelgruen);\n  font-family: 'Material Symbols Outlined';\n  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 40;\n  font-size: 30px;\n}\n\n.filter-head button {\n  flex-shrink: 0; /* Prevent the button from growing */\n  width: auto; /* Set a smaller width for the button */\n  padding: 5px 15px; /* Adjust padding for a smaller button */\n  font-family: 'Staatliches', sans-serif;\n  font-weight: normal;\n  background-color: var(--primary-dark); /* Distinct background color */\n  color: var(--primary-light); /* Text color */\n  cursor: pointer;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  margin-top: 0px;\n}\n\n.filter-head button:hover {\n  background-color: #ed5622; /* Hover effect */\n  color: var(--primary-dark); /* Invert text color on hover */\n}\n\n.filter-head .filter-text {\n  display: inline-block;\n  padding: 5px 15px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1em;\n  color: var(--dunkelgruen);\n  transition: background-color 0.3s ease, color 0.3s ease;\n  height: 10%;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n}\n\n.filter-text {\n  display: inline-block;\n  padding: 5px 15px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1em;\n  color: var(--dunkelgruen);\n  transition: background-color 0.3s ease, color 0.3s ease;\n  height: 10%;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n}\n\n.filter-head .filter-text.selected {\n  background-color: #ed5622; /* Highlight background when selected */\n  color: var(--primary-light); /* Invert text color when selected */\n}\n\n.filter-text.selected svg path{\n  color: var(--primary-light)\n}\n\n.filters .filter-text.selected {\n  background-color: #ed5622; /* Highlight background when selected */\n  color: var(--primary-light); /* Invert text color when selected */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
